import React from "react";
import { motion } from "framer-motion";
import { LeaderboardEntry } from "@uno/protocol";
import PodiumCard from "./PodiumCard";

type Props = {
    entries: LeaderboardEntry[];
    myPlayerId?: string;
};

const Podium: React.FC<Props> = ({ entries, myPlayerId }) => {
    const first = entries.find((e) => e.rank === 1);
    const second = entries.find((e) => e.rank === 2);
    const third = entries.find((e) => e.rank === 3);

    return (
        <div className="relative w-full max-w-[420px] mx-auto flex items-end justify-center gap-1 sm:gap-2 md:gap-3 py-3 md:py-4">
            {second && (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.15, duration: 0.4, ease: "backOut" }}
                    className="w-[30%]"
                >
                    <PodiumCard entry={second} isMe={second.playerId === myPlayerId} />
                </motion.div>
            )}

            {first && (
                <motion.div
                    initial={{ opacity: 0, y: 30, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ delay: 0, duration: 0.5, ease: "backOut" }}
                    className="relative w-[36%]"
                >
                    <div
                        className="absolute -top-2 md:-top-3 left-1/2 -translate-x-1/2 z-40 pointer-events-none"
                        aria-hidden="true"
                    >
                        <svg className="w-5 h-5 md:w-7 md:h-7 drop-shadow-[0_2px_4px_rgba(0,0,0,0.4)]" viewBox="0 0 24 24" fill="#fbbf24" stroke="#78350f" strokeWidth="1.2" strokeLinejoin="round">
                            <path d="M3 7l4 10h10l4-10-6 4-3-6-3 6-6-4z" />
                            <circle cx="3" cy="7" r="1.4" fill="#fbbf24" stroke="#78350f" strokeWidth="1" />
                            <circle cx="21" cy="7" r="1.4" fill="#fbbf24" stroke="#78350f" strokeWidth="1" />
                            <circle cx="12" cy="4" r="1.4" fill="#fbbf24" stroke="#78350f" strokeWidth="1" />
                        </svg>
                    </div>
                    <PodiumCard entry={first} isMe={first.playerId === myPlayerId} />
                </motion.div>
            )}

            {third && (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.4, ease: "backOut" }}
                    className="w-[30%]"
                >
                    <PodiumCard entry={third} isMe={third.playerId === myPlayerId} />
                </motion.div>
            )}
        </div>
    );
};

export default Podium;
